/**
 * Below-the-fold credibility row. Four scannable data points in card-style
 * tiles. Replaces marketing fluff with hard numbers a buyer can compare.
 */
const STATS = [
  { label: "Tolerance", value: "±0.005\"", note: "Standard" },
  { label: "Materials", value: "6061 · 7075 · 303 SS", note: "And More" },
  { label: "Lead Time", value: "1-2 Weeks", note: "As Fast As" },
  { label: "Location", value: "Colorado, USA", note: "Denver" },
] as const;

export function StatsRow() {
  return (
    <div className="grid w-full auto-rows-fr grid-cols-1 overflow-hidden rounded-lg border border-bg-border sm:grid-cols-2">
      {STATS.map(({ label, value, note }) => (
        <div key={label} className="flex flex-col justify-center gap-1 bg-bg-card/85 backdrop-blur-[8px] px-6 py-3">
          <span className="text-sm font-medium uppercase tracking-[0.18em] text-slate-400">
            {label}
          </span>
          <span className="text-lg font-semibold text-white sm:text-2xl">
            {value}
          </span>
          {note && <span className="text-xs text-slate-400">{note}</span>}
        </div>
      ))}
    </div>
  );
}
